import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Logout from './Logout';

const mapStateToProps = (state) => ({
  globalSettings: state.globalSettingsManager.globalSettings,
});

export default withRouter(connect(mapStateToProps, null)(Logout));
